.styledInput {
    border-radius: var(--mantine-radius-sm);
    background: var(--mantine-color-dark-5);
    border: 1px solid var(--mantine-color-dark-3);
    font-size: var(--mantine-font-size-xs);
}

.optionsWrapper {
    background: var(--mantine-color-dark-5);
    margin: none;
}

.dropdown {
    background: var(--mantine-color-dark-5);
    border-radius: var(--mantine-radius-sm);
}

.option {
    width: 100%;
    background: var(--mantine-color-dark-5);
    cursor: pointer;
    font-size: var(--mantine-font-size-xs);
    &:hover {
        background: #1c20266b;
    }
}
